<template>
  <div>
    <div class="userprofile mt-2 mb-2">
      <div class="closeBtn mb-2 text-right">
        <p @click="$router.push({ name: 'institute' })" class="btn m-0">
          <i class="fas fa-window-close fa-4x text-danger"></i>
        </p>
      </div>
      <b-container fluid>
        <b-row>
          <!-- Profile Sidebar -->
          <b-col md="3">
            <div class="profile">
              <div>
                <b-skeleton-img v-if="fetchData"></b-skeleton-img>
                <div v-else>
                  <b-overlay :show="loadImage" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
                    <b-form-file
                      ref="profileImage"
                      style="display: none"
                      accept=".jpg,.jpeg,.png"
                      @change="checkuserImage"
                    ></b-form-file>

                    <img
                      v-if="!cropperImg"
                      :src="img"
                      class="img-fluid img-thumbnail"
                      alt="Profile Image"
                      @click="selectUserImg"
                    />

                    <cropper v-else :src="cropperImg" @change="onCropChange" />

                    <div class="text-center mt-2">
                      <b-button v-if="cropperImg" variant="info" @click="submitImg">Upload Image</b-button>
                    </div>
                  </b-overlay>
                </div>

                <div class="mt-2">
                  <b-skeleton v-if="fetchData" animation="throb" width="50%"></b-skeleton>
                  <p v-else class="name d-flex align-items-center justify-content-center font-weight-bolder">
                    {{ userProfile.first_name ? userProfile.first_name + ' ' + (userProfile.last_name || '') : 'Full Name' }}
                  </p>
                </div>
              </div>
              
              <!-- Bio Section -->
              <div class="mt-3 text-center">
                <div class="d-inline-flex align-items-center">
                  <h5 class="font-weight-bold mb-0 mr-2">Bio Info</h5>
                  <b-button v-if="!isEditingBio" size="sm" variant="link" @click="isEditingBio = true">
                    <i class="fas fa-edit text-info" style="font-size: 18px !important;"></i>
                  </b-button>
                </div>

                <div class="mt-2">
                  <div v-if="!isEditingBio">
                    <p class="text-muted">{{ userProfile.bio || 'No bio added yet.' }}</p>
                  </div>

                  <div v-else>
                    <b-form-textarea
                      v-model="userProfile.bio"
                      rows="3"
                      placeholder="Enter your bio (max 250 characters)"
                      maxlength="250"
                    ></b-form-textarea>
                    <div class="mt-2">
                      <b-button size="sm" variant="success" @click="saveBio">Save</b-button>
                      <b-button size="sm" variant="secondary" @click="isEditingBio = false">Cancel</b-button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Navigation Options -->
              <div class="userOptions mt-2">
                <div class="mt-2 d-flex justify-content-center" v-if="fetchData">
                  <b-skeleton type="button" animation="throb"></b-skeleton>
                  <b-skeleton type="button" animation="throb"></b-skeleton>
                  <b-skeleton type="button" animation="throb"></b-skeleton>
                </div>
                <b-nav vertical v-else>
                  <b-nav-item
                    :active="activeComponent == userIndex ? true : false"
                    v-for="(user, userIndex) in userOptions"
                    :key="userIndex"
                    @click="switchUserData(user.component, userIndex)"
                  >
                    {{ user.name }}
                  </b-nav-item>
                </b-nav>
              </div>
            </div>
          </b-col>

          <!-- Dynamic Component -->
          <b-col>
            <component
              :is="currentComponent"
              :userProfile="userProfile"
              :profile="userProfile"
              :user="userInfo"
              @profileUpdated="getUserProfile"
              @ProfileCancelled="(activeComponent = 0), (currentComponent = 'About')"
              @editProfile="switchUserData('EditProfile', null)"
            ></component>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import About from "./UserOptions/About.vue";
import EditProfile from "./UserOptions/EditProfile.vue";
import FacultyProfile from "./MyProfileNew.vue";
import StudentProfile from "@/components/templates/Dashboard/Institute/usergroups/usersubgroups/subgroup_users_edit/ViewProfile.vue";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  async created() {
    this.fetchData = true;
    this.cloudStorageRoot = this.$store.getters.getAPIKey.userAttachments;

    await this.getInstitutionRoles();
    await this.setupUserOptions();
    await this.initializeImg();

    this.fetchData = false;
  },
  components: {
    About,
    FacultyProfile,
    EditProfile,
    StudentProfile,
    Cropper,
  },
  data() {
    return {
      isEditingBio: false,
      fetchData: false,
      loadImage: false,
      cropperImg: null,
      img: "https://monstar-lab.com/global/wp-content/uploads/sites/11/2019/04/male-placeholder-image.jpeg",
      institutionRolesOptions: [],
      userRolesObject: {},
      userOptions: [],
      currentComponent: "About",
      activeComponent: 0,
      profileImage: null,
    };
  },
  computed: {
    selectedInstitute() {
      return this.$store.getters.getCurrentInstitution;
    },
    myIinstitutionEnrollmets() {
      return this.$store.getters.getInstitutes;
    },
    userProfile() {
      return this.$store.getters.getMyProfile;
    },
    userInfo() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    async initializeImg() {
      if (this.userProfile?.profile_image) {
        this.img =
          this.cloudStorageRoot +
          this.userProfile.profile_image.file_path +
          this.userProfile.profile_image.file_name;
      }
    },
    setupUserOptions() {
      const options = [{ name: "Basic Profile Info", component: "About" }];

      if (Object.values(this.userRolesObject).includes("Faculty")) {
        options.push({ name: "My Faculty Profile", component: "FacultyProfile" });
      }

      if (Object.values(this.userRolesObject).includes("Student")) {
        options.push({ name: "My Student Profile", component: "StudentProfile" });
      }

      this.userOptions = options;
    },
    async getInstitutionRoles() {
      this.institutionRolesOptions = [{ value: null, text: "Select Role", disabled: true }];

      this.myIinstitutionEnrollmets.forEach((institute) => {
        if (this.selectedInstitute?.id === institute.institution.id) {
          this.$set(
            this.userRolesObject,
            institute.id,
            institute.institution_role.name === "teacher"
              ? "Faculty"
              : institute.institution_role.name.charAt(0).toUpperCase() +
                institute.institution_role.name.slice(1)
          );
        }
      });
    },
    async saveBio() {
      await this.$store.dispatch("storeUserProfile", { bio: this.userProfile.bio });
      this.isEditingBio = false;
    },
    checkuserImage(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        this.cropperImg = reader.result;
      };
      reader.readAsDataURL(file);
    },
    selectUserImg() {
      const input = this.$refs.profileImage.$el.querySelector('input[type="file"]');
      input.click();
    },
    onCropChange({ canvas }) {
      this.img = canvas.toDataURL("image/png");
    },
    async submitImg() {
      if (!this.img) return;
      this.loadImage = true;
      this.cropperImg = null;

      await this.$store.dispatch("storeUserProfile", {
        base64_profile_picture: this.img,
      });

      this.loadImage = false;
    },
    async getUserProfile() {
      this.fetchData = true;
      await this.$store.dispatch("getMyProfile");
      this.currentComponent = "About";
      this.activeComponent = 0;
      await this.initializeImg();
      this.fetchData = false;
    },
    switchUserData(component, index) {
      this.currentComponent = component;
      this.activeComponent = index;
    },
  },
};
</script>

<style scoped>
.userprofile .row .col-md-3 .profile {
  max-width: 270px;
  min-height: 600px;
  padding: 10px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 15px;
  background-color: white;
  border-top: 5px solid rgb(0, 153, 255);
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}
.userprofile .row .col-md-3 {
  flex: 0 0 20%;
  max-width: 20%;
}
.userprofile .col-md-3 .profile img,
.userprofile .col-md-3 .b-aspect .b-skeleton {
  width: 100%;
  height: 200px;
  cursor: pointer;
  overflow: hidden;
}
.userprofile .col-md-3 .profile p.name {
  font-weight: 600;
  text-align: center;
}


.userprofile .row .col-md-3 {
  flex: 0 0 20%;
  max-width: 20%;
}

.userprofile .col-md-3 .profile i {
  font-size: 12px !important;
}
.userprofile .col-md-3 .profile img,
.userprofile .col-md-3 .b-aspect .b-skeleton {
  width: 100%;
  height: 200px;
  cursor: pointer;
  overflow: hidden;
}

.userprofile .col-md-3 .profile p {
  padding: 0px;
  margin: 10px;
}

.userprofile .col-md-3 .profile p.name {
  font-weight: 600;
  text-align: center;
}
.userprofile .col-md-3 .profile .nav .nav-item .nav-link {
  background-color: #1ea2ed;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 5px;
}

.userprofile .col-md-3 .profile .nav .nav-item a.active {
  background-color: #f0efef;
  color: #1ea2ed;
  font-weight: 900;
}

@media only screen and (max-width: 600px) and (orientation: portrait) {
  .userprofile .row .col-md-3 {
    flex: none;
    max-width: none;
  }
}
</style>
